import { Component } from "react";
import { connect } from "react-redux";
import logo from "images/medium-logo-without-text.png";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Image from "react-graceful-image";
import Container from "react-bootstrap/Container";
import {
  isIndividualPlan,
  isInstitutionalPlan,
  isOpenRemunerationPlan,
  isProfilePlan,
  isPublicUser,
  isRealInstitutionalParentPlan,
  isStarterPlan,
  viewAdvancedFeatureVisible,
  viewJobFeatureVisible,
} from "shared/plans";
import DashboardSearch from "./DashboardSearch";
import BoardSummaryDropdown from "../BoardSummaryDropdown";
// import UserReports from '../../sections/UserReports';
import { Button } from "react-bootstrap";
import { mixpanelTrack } from "../../../shared/trackEvents/mixpanelTracking";
import {
  OPEN_REMUNERATION_EVENT_NAMES,
  OPEN_DIRECTOR_EVENT_NAMES,
  MIXPANEL_PROPS,
} from "shared/trackEvents/constants";

const companiesAtRiskInfo =
  "This is a list of companies where executives may be interested in moving companies. OpenDirector looks at factors like if the company has a new CEO, total shareholder returns, executive turnover, director share trading, board strikes and other factors.";
const ceoAtRiskInfo =
  "This is a ranking of CEOs who OpenDirector believes are at risk of losing their positions. CEO's are ranked based on comparative changes in shareholder total return, remuneration, director share trading, board strikes and other factors.";

class SideBarAndNavBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openRemUser: isOpenRemunerationPlan(props.user),
      publicUser: isPublicUser(props.user),
    };
  }

  _trackNavigationClick = ({ pageName, section }) => {
    if (this.state.openRemUser) {
      return mixpanelTrack(OPEN_REMUNERATION_EVENT_NAMES.PAGE_CLICKED, {
        [MIXPANEL_PROPS.PAGE_NAME]: pageName,
        [MIXPANEL_PROPS.SECTION]: section,
        userEmail: this.props.user?.email,
      });
    } else {
      return mixpanelTrack(OPEN_DIRECTOR_EVENT_NAMES.PAGE_CLICKED, {
        [MIXPANEL_PROPS.PAGE_NAME]: pageName,
        [MIXPANEL_PROPS.SECTION]: section,
        userEmail: this.props.user?.email,
      });
    }
  };

  _renderTooltip = (text, id) => {
    return (
      <OverlayTrigger
        placement="right"
        overlay={<Tooltip id={`coming-soon-tooltip-${id}`}>{text}</Tooltip>}
      >
        <span className="fa fa-info ml-3"></span>
      </OverlayTrigger>
    );
  };

  componentDidMount() {
    window.addEventListener("hashchange", this.handleRouteChange);
  }

  componentWillUnmount() {
    window.removeEventListener("hashchange", this.handleRouteChange);
  }

  handleRouteChange = () => {
    this.setState({ currentPath: window.location.hash });
  };

  _navPermClass = (type) => {
    const { user } = this.props;
    const { currentPath } = this.state;

    const profileUser = isProfilePlan(user);
    const institutionalUser = isInstitutionalPlan(user);
    const institutionalSingleUser = isIndividualPlan(user);
    const starterUser = isStarterPlan(user);
    const validStarterPlan = starterUser || profileUser;
    const validInstitutionalPlan = institutionalUser || institutionalSingleUser;
    const validOpenDirectorSubscription =
      validStarterPlan || validInstitutionalPlan;
    const advancedFeature = viewAdvancedFeatureVisible(user);
    const jobFeature = viewJobFeatureVisible(user);

    const isCurrentPage =
      (type === "listed-companies" && currentPath === "#/organisations") ||
      (type === "power-search" && currentPath === "#/search") ||
      (type === "consolidate-networks" && currentPath === "#/networks") ||
      (type === "remuneration-policy" &&
        currentPath === "#/remuneration-policy") ||
      (type === "ceo-rem-comp" &&
        currentPath === "#/ceo-remuneration-components") ||
      (type === "board-policy" && currentPath === "#/board-policy") ||
      (type === "exec-comp" && currentPath === "#/rem-compare") ||
      (type === "board-main" && currentPath === "#/boards") ||
      (type === "executive-main" && currentPath === "#/executives") ||
      (type === "my-profile" && currentPath === "#/member-profile") ||
      (type === "bubbles-main" && currentPath === "#/bubbles");

    if (isCurrentPage) {
      return "nav-current";
    }

    let className;
    switch (type) {
      case "power-search":
      case "consolidate-networks":
      case "companies-risk":
      case "rank-company":
      case "rank-director":
      case "rank-executive":
      case "analysis":
      case "director-renewal":
      case "director-share-buy":
      case "director-skill":
      case "director-committee":
      case "exec-departure":
      case "exec-risk":
      case "rem-viz":
        className = "nav-active";
        break;
      case "exec-comp":
        className = "nav-active";
        break;
      case "exec-summary":
      case "stat":
        className = validInstitutionalPlan ? "nav-active" : "nav-inactive";
        break;
      case "director-connection":
        className =
          validInstitutionalPlan || profileUser ? "nav-active" : "nav-inactive";
        break;
      case "executive-connection":
        className =
          validInstitutionalPlan || profileUser ? "nav-active" : "nav-inactive";
        break;
      case "rem-main":
      case "exec-comp-rem":
      case "board-comp-rem":
      case "ceo-rem-comp":
      case "board-policy":
      case "remuneration-policy":
      case "listed-companies":
        className = "nav-active";
        break;
      case "report-main":
      case "board-count":
      case "esg":
      case "premium-main":
      case "exec-changes":
      case "director-change":
        className = validOpenDirectorSubscription
          ? "nav-active"
          : "nav-inactive";
        break;
      case "rank":
        className = validInstitutionalPlan
          ? "nav-drop-active"
          : "nav-drop-inactive";
        break;
      case "advance-feature":
        className = advancedFeature ? "nav-drop-active" : "nav-drop-inactive";
        break;
      case "position-post":
        className = jobFeature ? "nav-active" : "nav-inactive";
        break;
      case "my-profile":
      default:
        className = "nav-active";
    }

    return className;
  };
  _renderSideBar = () => {
    const { user } = this.props;
    const { openRemUser } = this.state;

    return (
      <div bg="primary" className="react-sidebar">
        <div style={{ position: "sticky" }}>
          <a
            href="#/root"
            className="py-4"
            style={{
              borderBottom: "1px solid #71C6CC",
              backgroundColor: "#001F38",
            }}
            onClick={() =>
              this._trackNavigationClick({
                pageName: "Home",
                section: "Home",
              })
            }
          >
            <Image
              src={logo}
              style={{ width: 32, height: 32, borderRadius: 3 }}
              alt="Product Logo"
            />
          </a>
        </div>
        <ul style={{ marginBottom: "5rem" }}>
          {!openRemUser && (
            <>
              <li>
                <a
                  href="#/organisations"
                  className={this._navPermClass("listed-companies")}
                  onClick={() =>
                    this._trackNavigationClick({
                      pageName: "Organisations",
                      section: "Organisations",
                    })
                  }
                >
                  <span className="fa fa-table-list fa-2x" />
                  <br />
                  Organisations
                </a>
              </li>
              <li>
                <a
                  href="#/search"
                  className={this._navPermClass("power-search")}
                  onClick={() =>
                    this._trackNavigationClick({
                      pageName: "Power Search",
                      section: "Power Search",
                    })
                  }
                >
                  <span className="fa fa-globe-asia fa-2x mt-0" />
                  <br />
                  Power Search
                </a>
              </li>
            </>
          )}

          {openRemUser && (
            <>
              <li>
                <a
                  href="#/organisations"
                  className={this._navPermClass("listed-companies")}
                  onClick={() =>
                    this._trackNavigationClick({
                      pageName: "Organisations",
                      section: "Organisations",
                    })
                  }
                >
                  <span className="fa fa-table-list fa-2x" />
                  <br />
                  Organisations
                </a>
              </li>

              <li>
                <a
                  href="#/remuneration-policy"
                  className={this._navPermClass("remuneration-policy")}
                  onClick={() =>
                    this._trackNavigationClick({
                      pageName: "Remuneration Policy",
                      section: "Remuneration Policy",
                    })
                  }
                >
                  <span className="fa fa-spa fa-2x" />
                  <br />
                  Executive Remuneration Package
                </a>
              </li>

              <li>
                <a
                  href="#/ceo-remuneration-components"
                  className={this._navPermClass("ceo-rem-comp")}
                  onClick={() =>
                    this._trackNavigationClick({
                      pageName: "Proxy Advisor Estimates",
                      section: "Proxy Advisor Estimates",
                    })
                  }
                >
                  <span className="fa fa-drafting-compass fa-2x" />
                  <br />
                  Proxy Advisor Estimates
                </a>
              </li>

              <li>
                <a
                  href="#/board-policy"
                  className={this._navPermClass("board-policy")}
                  onClick={() =>
                    this._trackNavigationClick({
                      pageName: "Board Details",
                      section: "Board Details",
                    })
                  }
                >
                  <span className="fa fa-graduation-cap fa-2x" />
                  <br />
                  Board Details
                </a>
              </li>

              <li>
                <a
                  href="#/search"
                  className={this._navPermClass("power-search")}
                  onClick={() =>
                    this._trackNavigationClick({
                      pageName: "Power Search",
                      section: "Power Search",
                    })
                  }
                >
                  <span className="fa fa-globe-asia fa-2x mt-0" />
                  <br />
                  Power Search
                </a>
              </li>

              <li>
                <a
                  href="#/networks"
                  className={this._navPermClass("consolidate-networks")}
                  onClick={() =>
                    this._trackNavigationClick({
                      pageName: "Consolidate Networks",
                      section: "Consolidate Networks",
                    })
                  }
                >
                  <span className="fa fa-network-wired fa-2x mt-0" />
                  <br />
                  Networks
                </a>
              </li>

              <li>
                <a
                  href="#/rem-compare"
                  className={this._navPermClass("exec-comp")}
                  onClick={() =>
                    this._trackNavigationClick({
                      pageName: "Executive Comparison",
                      section: "Executive Comparison",
                    })
                  }
                >
                  <span className="fa fa-microchip fa-2x" />
                  <br />
                  Executive Comparison
                </a>
              </li>
            </>
          )}

          {/* <li>
            <a href="#/boards" className={this._navPermClass("board-main")}>
              <span className="fa fa-users fa-2x" />
              <br />
              Boards
            </a>
          </li>
          <li>
            <a
              href="#/executives"
              className={this._navPermClass("executive-main")}
            >
              <span className="fa fa-briefcase fa-2x" />
              <br />
              Executives
            </a>
          </li> */}
          {!openRemUser && (
            <>
              <li>
                <a
                  href="#/networks"
                  className={this._navPermClass("consolidate-networks")}
                >
                  <span className="fa fa-network-wired fa-2x mt-0" />
                  <br />
                  Networks
                </a>
              </li>
              <li>
                <a
                  href="#/member-profile"
                  className={this._navPermClass("my-profile")}
                  onClick={() =>
                    this._trackNavigationClick({
                      pageName: "Profile Page",
                      section: "User Menu",
                    })
                  }
                >
                  <span className="fa fa-address-card fa-2x" />
                  <br />
                  My Profile
                </a>
              </li>
              {/* <li>
                            <a href="/jobs" className={this._navPermClass("position-view")}>
                                <span className='fas fa-user-md fa-2x'/>
                                <br/>
                                Available Directorships
                            </a>
                        </li> */}

              <li>
                <a
                  href="#/bubbles"
                  className={this._navPermClass("bubbles-main")}
                  onClick={() =>
                    this._trackNavigationClick({
                      pageName: "Bubbles",
                      section: "Bubbles",
                    })
                  }
                >
                  <span className="fa fa-soap fa-2x" />
                  <br />
                  Bubbles
                </a>
              </li>
            </>
          )}
        </ul>
      </div>
    );
  };

  render() {
    const { user } = this.props;
    const { openRemUser, publicUser } = this.state;

    const profileUser = isProfilePlan(user);
    const institutionalUser = isInstitutionalPlan(user);
    const realInstitutionalParentUser = isRealInstitutionalParentPlan(user);
    const advancedFeature = viewAdvancedFeatureVisible(user);

    const titleName = "Core Information";
    return (
      <>
        <Navbar
          bg="white"
          expand="lg"
          style={{
            zIndex: 1,
            position: "unset",
            height: "5rem",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          <Container style={{ maxWidth: "100%" }}>
            <Navbar.Brand
              href="#/root"
              style={{ width: "80px" }}
              onClick={() =>
                this._trackNavigationClick({
                  pageName: "Home",
                  section: "Home",
                })
              }
            >
              <Image
                src={logo}
                style={{ width: 38, height: 38, borderRadius: 3 }}
                alt="Application Logo"
              />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <div className="d-flex w-100 align-items-center">
                {/* Left side - Search */}
                <div
                  style={{
                    flex: "1",
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  <DashboardSearch />
                </div>

                {/* Center - Board Summary Dropdown */}
                <div style={{ flex: "0 0 auto" }}>
                  <BoardSummaryDropdown />
                </div>

                {/* Right side - Navigation items */}
                <div
                  style={{
                    flex: "1",
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                >
                  <Nav className="text-nowrap align-items-center">
                    <NavDropdown
                      title={titleName}
                      id="premium-nav-dropdown"
                      alignRight
                      className={this._navPermClass("premium-main")}
                    >
                      {/* <NavDropdown.Item
                    href="#"
                    className="pl-2 text-primary"
                    style={{ pointerEvents: "none" }}
                  >
                    Networks
                  </NavDropdown.Item> */}
                      {/* <NavDropdown.Item href="#/company-risks"
                                                        className={this._navPermClass("companies-risk")}>
                                        Companies at risk
                                        {this._renderTooltip(companiesAtRiskInfo, '1')}
                                    </NavDropdown.Item>
                                    <NavDropdown.Item href="#/executive-risks"
                                                        className={this._navPermClass("exec-risk")}>
                                        CEOs at risk
                                        {this._renderTooltip(ceoAtRiskInfo, '2')}
                                    </NavDropdown.Item> */}
                      {/* <NavDropdown.Item
                    href="#/connections"
                    className={this._navPermClass("director-connection")}
                  >
                    Director Networks
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    href="#/executive-connections"
                    className={this._navPermClass("executive-connection")}
                  >
                    Executive Networks
                  </NavDropdown.Item> */}

                      {
                        // <NavDropdown.Divider/>
                        // <NavDropdown.Item href='#'
                        //                   className='pl-2 disabled'>Analytics</NavDropdown.Item>
                        // <NavDropdown className={`${this._navPermClass("rank")} sub-dropdown ml-3`}
                        //              title="Director and Company Rankings"
                        //              id="rankings-nav-dropdown">
                        //     <NavDropdown.Item href="#/company-ranking"
                        //                       className={this._navPermClass("rank-company")}>Company</NavDropdown.Item>
                        //     <NavDropdown.Item href="#/director-ranking"
                        //                       className={this._navPermClass("rank-director")}>Director</NavDropdown.Item>
                        //     <NavDropdown.Item href="#/executive-ranking"
                        //                       className={this._navPermClass("rank-executive")}>Executive</NavDropdown.Item>
                        // </NavDropdown>
                        // <NavDropdown.Item href="#/director-analysis"
                        //                   className={this._navPermClass("analysis")}>Director Return
                        //     Analysis</NavDropdown.Item
                      }

                      {/* <NavDropdown.Divider /> */}
                      <NavDropdown.Item
                        href="#"
                        className="pl-2 text-primary"
                        style={{ pointerEvents: "none" }}
                      >
                        Directors
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        href="#/non-executive-director-changes"
                        className={this._navPermClass("director-change")}
                        onClick={() =>
                          this._trackNavigationClick({
                            pageName: "Non-Executive Director Changes",
                            section: "Core Information",
                          })
                        }
                      >
                        Non-Executive Director Changes
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        href="#/non-executive-director-renewals"
                        className={this._navPermClass("director-renewal")}
                        onClick={() =>
                          this._trackNavigationClick({
                            pageName: "Non-Executive Director Renewals",
                            section: "Core Information",
                          })
                        }
                      >
                        Non-Executive Director Renewals
                      </NavDropdown.Item>
                      {/* <NavDropdown.Item href="#/company-director-shares"
                                                        className={this._navPermClass("director-share-buy")}>Director
                                        Shares Buys/Sells</NavDropdown.Item> */}
                      <NavDropdown.Item
                        href="#/skills-diversity"
                        className={this._navPermClass("director-skill")}
                        onClick={() =>
                          this._trackNavigationClick({
                            pageName: "Board Skills and Experience",
                            section: "Core Information",
                          })
                        }
                      >
                        Board Skills and Experience
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        href="#/committee-membership"
                        className={this._navPermClass("director-committee")}
                        onClick={() =>
                          this._trackNavigationClick({
                            pageName: "Committee Membership",
                            section: "Core Information",
                          })
                        }
                      >
                        Committees
                      </NavDropdown.Item>

                      <NavDropdown.Divider />
                      <NavDropdown.Item
                        href="#"
                        className="pl-2 text-primary"
                        style={{ pointerEvents: "none" }}
                      >
                        Executives
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        href="#/executive-changes"
                        className={this._navPermClass("exec-changes")}
                        onClick={() =>
                          this._trackNavigationClick({
                            pageName: "Recent Executive Changes",
                            section: "Core Information",
                          })
                        }
                      >
                        Recent Executive Changes
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        href="#/executive-departures"
                        className={this._navPermClass("exec-departure")}
                        onClick={() =>
                          this._trackNavigationClick({
                            pageName: "Executive Departures/Arrivals",
                            section: "Core Information",
                          })
                        }
                      >
                        Executive Departures/Arrivals
                      </NavDropdown.Item>
                    </NavDropdown>

                    <Nav.Link
                      href="#/reports"
                      onClick={() =>
                        this._trackNavigationClick({
                          pageName: "Reports",
                          section: "Reports",
                        })
                      }
                    >
                      Reports
                    </Nav.Link>

                    {publicUser ? (
                      <>
                        <Nav.Link
                          href="/users/sign_in"
                          style={{ marginLeft: "2rem" }}
                          onClick={() =>
                            this._trackNavigationClick({
                              pageName: "Login",
                              section: "User Menu",
                            })
                          }
                        >
                          Login
                        </Nav.Link>
                      </>
                    ) : (
                      <NavDropdown
                        title={
                          <span
                            className="fa fa-user-circle"
                            style={{ color: "#00AAB2", fontSize: "2.5rem" }}
                          />
                        }
                        id="reports-nav-dropdown"
                        alignRight
                        className="user-round-nav"
                      >
                        {(profileUser || institutionalUser) && (
                          <NavDropdown.Item
                            href="#/member-profile"
                            onClick={() =>
                              this._trackNavigationClick({
                                pageName: "Profile Page",
                                section: "User Menu",
                              })
                            }
                          >
                            Profile page
                          </NavDropdown.Item>
                        )}
                        {realInstitutionalParentUser && (
                          <NavDropdown.Item
                            href="#/member-user"
                            onClick={() =>
                              this._trackNavigationClick({
                                pageName: "Manage Users",
                                section: "User Menu",
                              })
                            }
                          >
                            Manage Users
                          </NavDropdown.Item>
                        )}
                        <NavDropdown.Item
                          href="#/lists"
                          onClick={() =>
                            this._trackNavigationClick({
                              pageName: "Lists",
                              section: "User Menu",
                            })
                          }
                        >
                          Lists
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          href="#/positions"
                          onClick={() =>
                            this._trackNavigationClick({
                              pageName: "Post Positions",
                              section: "User Menu",
                            })
                          }
                        >
                          Post Positions
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          href="#/notifications"
                          onClick={() =>
                            this._trackNavigationClick({
                              pageName: "Notifications",
                              section: "User Menu",
                            })
                          }
                        >
                          Notifications
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          href="#/settings"
                          onClick={() =>
                            this._trackNavigationClick({
                              pageName: "Settings",
                              section: "User Menu",
                            })
                          }
                        >
                          Settings
                        </NavDropdown.Item>
                      </NavDropdown>
                    )}
                    <Button
                      variant="outline-primary"
                      size="md"
                      style={{ borderRadius: 0 }}
                      href={"/users/sign_out"}
                      onClick={() =>
                        this._trackNavigationClick({
                          pageName: "Logout",
                          section: "User Menu",
                        })
                      }
                    >
                      Logout
                    </Button>
                  </Nav>
                </div>
              </div>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        {this._renderSideBar()}
      </>
    );
  }
}

function mapStateToProps(state) {
  const { users } = state;

  return {
    user: users.user,
  };
}

export default connect(mapStateToProps, null)(SideBarAndNavBar);
